import {
    createSelector
} from 'reselect';

export const linkedUsersSelector = createSelector(state => state && state.userManagement && state.userManagement.users, linkedUsersSelector => linkedUsersSelector);
export const rolesSelector = createSelector(state => state && state.userManagement && state.userManagement.roles, rolesSelector=>rolesSelector )
export const locationDetailSelector = createSelector(state => state && state.userManagement && state.userManagement.locationDetail, locationDetailSelector=>locationDetailSelector )
